export default __webpack_public_path__ + "static/media/sclogo.8144f89b.svg";